// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"a3f0dd23","752":"13ff5dc9"}[chunkId] + ".chunk.css";
};